import { useHistory } from "react-router-dom";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SegmentHistoryListener = ({ children, ...props }) => {
  //Because we are on a Single Page App,
  //we need to listen to history changes for the analytics to know we are on a different page
  const history = useHistory();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!history || !t || !i18n) {
      return;
    }

    //The first page load
    window.analytics.page();

    //Every time there is a history change, we log it
    return history.listen((location) => {
      window.analytics.page();
    });
  }, [history, t, i18n]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default SegmentHistoryListener;
